module.exports = __webpack_public_path__ + "static/vatnsnes-map-b666b6de75c8e9f2b18af06976192181.svg";